module.exports = __webpack_public_path__ + "static/Acta-Book-5e45146373d8571e7c0d8608bf0c20a4.woff";